module.exports = __webpack_public_path__ + "img/mail-black.6512878f.svg";